import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {useHttp} from "../../hooks/use-http";
import {NewsListItem} from "./NewsListItem";
import {LoadingNewsListItem} from "../../components/Extra/Loading/LoadingNewsListItem";
import {NewsListContainer} from "../../utils/common-styles";
import {FilteredListHeader} from "../../components/Extra/FilteredListHeader";

export const NewsList = () => {
    const [newsItems, setNewsItems] = useState([]);
    const {error, isLoading, sendRequest: getContent} = useHttp();
    const [filterType, setFilterType] = useState('');
    const params = useParams();

    const type = params.filterType ? params.filterType : '';
    const value = params.filterValue ? params.filterValue : '';
    const extra = params.filterExtra ? params.filterExtra : '';

    useEffect(() => {

        const transformResponse = (data) => {
            setNewsItems(data.payload?.news ? data.payload.news : []);
            setFilterType(data.payload?.filterText ? data.payload.filterText : '');
        };

        let url = '/news/list';
        if (type === 'date') {
            url = '/news/list/date/' + value;
        }

        if (type === 'tag') {
            url = '/news/list/tag/' + value;
        }

        getContent({url: url}, transformResponse);
    }, [type, value, extra, getContent]);


    return (
        <NewsListContainer>
            {error && <p>{error}</p>}
            {type === 'date' && (
                <div><FilteredListHeader title="News stories posted for" clearFilterLink="/news/list" tagLabel={filterType} /></div>
            )}
            {type === 'tag' && (
                <div><FilteredListHeader title="News stories tagged with" clearFilterLink="/news/list" tagLabel={filterType} /></div>
            )}
            {isLoading && Array.from({length: 5}).map((_, index) => (
                <LoadingNewsListItem key={index} />
            ))}
            {!isLoading && newsItems.length > 0 && newsItems.map((item) => (
                <NewsListItem key={item.id} post={item} />
            ))}
            {!isLoading && newsItems.length === 0 && (
                <p>No news items found</p>
            )}
        </NewsListContainer>
    );
};
